<!-- 订单页的商品信息 -->
<template>
  <div class="goodsinfo">
    <div class="goods">
      <div class="main">
        <div class="main-inner">
          <h1 class="title">{{name}}</h1>
          <p class="tip">{{content}}</p>
        </div>
      </div>
      <div class="left">
        <div class="goods-pic" v-if="!goodsIcon && goodsType === 'vip'"></div>
        <img :src="goodsIcon" class="goods-icon" :onerror="defaultCoverUrl" alt="cover" v-if="goodsIcon">
      </div>
      <div class="right">
        <p class="unit-price">￥<span class="num">{{priceLabel}}</span></p>
      </div>
    </div>

    <div class="discount-info" v-if="discountList.length">
      <div class="item" v-for="discount in discountList" :key="discount.discountId">
        <div class="label">{{discount.discountName}}</div>
        <div class="info light">-￥{{discount.discountPriceLabel}}</div>
      </div>
      <div class="item discounted-price">
        <div class="label">折后价格</div>
        <div class="info">￥{{account}}</div>
      </div>
    </div>

    <div class="subtotal">
      <div class="text">小计</div>
      <div class="price">￥<span class="num">{{account}}</span></div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { getGoodsInfo } from '@/api/goods'

export default {
  name: 'GoodsInfo',
  data() {
    return {
      defaultCoverUrl: 'this.src="' + require('../../assets/global/error.jpg') + '"',
      goodsIcon: '',
    }
  },
  computed: {
    ...mapGetters([
      'goodsId',
      'content',
      'desc',
      'name',
      'price',
      'priceLabel',
      'goodsType',
      'account',
      'discountDetail',
      'discountList',
    ]),
  },
  async created() {
    if (this.$route.query.goods_id) {
      try {
        this.$daidiLoading.show({
          text: '加载商品中，请稍候...',
        })
        await this.getGoodsInfo(this.$route.query.goods_id)
        this.$daidiLoading.hide()
      } catch (err) {
        window.history.go(-1)
      }
    }
  },
  methods: {
    async getGoodsInfo(goodsId) {
      let goodsInfo = await getGoodsInfo(goodsId, this.$store.getters.token)
      goodsInfo = goodsInfo.good_info
      console.log('商品信息: ', goodsInfo)
      if (goodsInfo.good_icon) {
        goodsInfo.obj_type == 'vip' ? this.goodsIcon = require('../../assets/order/order-icon.png') : this.goodsIcon = goodsInfo.good_icon
      }
      let discountList = []
      if (goodsInfo.discount_list) {
        goodsInfo.discount_list.forEach(item => {
          discountList.push({
            discountId: item.discount_id,
            discountPrice: item.discount_price,
            discountPriceLabel: item.discount_price_label,
            discountName: item.discount_name,
          })
        })
      }
      this.$store.dispatch('setOrderInfo', {
        goodsId: goodsInfo.good_id,
        goodsType: goodsInfo.obj_type,
        content: goodsInfo.good_content || '',
        desc: goodsInfo.good_desc || '',
        name: goodsInfo.good_name || '',
        price: goodsInfo.good_price,
        priceLabel: goodsInfo.good_price_label,
        account: goodsInfo.account,
        discountDetail: {
          discountTotalPrice: goodsInfo.discount_total_price || 0,
          discountTotalPriceLabel: goodsInfo.discount_total_price_label || '',
          discountedPrice: goodsInfo.discounted_price || 0,
        },
        discountList: discountList,
      })
    }
  },
}
</script>

<style lang="less" scoped>
  @import "~@/styles/fn";

  @line: 1px dashed rgba(0,0,0,.16);
  .goodsinfo {
    padding: 0 .4rem;
  }
  .goods {
    @right_w: 1.2rem;
    @left_w: 1.44rem;
    @box_h: 1.44rem;
    display: block;
    position: relative;
    padding: .24rem 0;
    width: 100%;
    border-top: @line;
    border-bottom: @line;
    box-sizing: border-box;
    overflow: hidden;
    .main, .left, .right {
      float: left;
      height: @box_h;
    }
    .left {
      margin-left: -100%;
      width: @left_w;
      .goods-pic {
        display: block;
        width: 1.44rem;
        height: 1.44rem;
        .bg("~@/assets/order/order-icon.png");
      }
      .goods-icon {
        display: block;
        width: 1.44rem;
        height: 1.44rem;
        border-radius: 3px;
      }
    }
    .right {
      position: relative;
      margin-left: -@right_w;
      width: @right_w;
      .unit-price {
        padding-top: .8rem;
        font-size: .28rem;
        color: #a0a0a6;
        text-align: right;
      }
    }
    .main {
      width: 100%;
      &-inner {
        margin-left: @left_w;
        margin-right: @right_w;
        padding-left: .1rem;
        min-height: @box_h;
        word-break: break-all;
        .title {
          padding-top: .1rem;
          font-size: .4rem;
          color: #6c6c74;
        }
        .tip {
          padding-top: .16rem;
          font-size: .28rem;
          color: #a0a0a6;
        }
      }
    }
  }

  .subtotal {
    display: flex;
    align-items: center;
    height: 1.2rem;
    border-bottom: @line;
    .text {
      flex: 1;
      font-size: .34rem;
      color: #6c6c74;
    }
    .price {
      width: 1.2rem;
      text-align: right;
      color: #fe7058;
    }
  }

  .discount-info {
    display: flex;
    flex-direction: column;
    align-items: center;
    // height: 1.2rem;
    border-bottom: @line;
    .item {
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 100%;
      height: 1.2rem;
      border-bottom: @line;
      &:last-child {
        border-bottom: none;
      }
    }
    .label {
      font-size: .32rem;
      color: #6c6c74;
    }
    .info {
      font-size: .28rem;
      color: #a0a0a6;
    }
    .light {
      color: #feb800;
    }
  }
</style>
